import { render, staticRenderFns } from "./CreateQuestionModal.vue?vue&type=template&id=773e40bc&scoped=true&"
import script from "./CreateQuestionModal.vue?vue&type=script&lang=js&"
export * from "./CreateQuestionModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateQuestionModal.vue?vue&type=style&index=0&id=773e40bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773e40bc",
  null
  
)

export default component.exports